import { render, staticRenderFns } from "./NextMaterialSection.vue?vue&type=template&id=52da99fc&"
import script from "./NextMaterialSection.vue?vue&type=script&lang=js&"
export * from "./NextMaterialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports